import { render } from "./ObjetivesLists.vue?vue&type=template&id=c84520ea"
import script from "./ObjetivesLists.vue?vue&type=script&lang=js"
export * from "./ObjetivesLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__